/* =====================================================================
   MOMENTUM — Night Run. Canvas dodge-the-traffic mini-game.
   Self-contained. Leaderboard in localStorage (top 10).
   ===================================================================== */
(function () {
  'use strict';
  var section = document.querySelector('[data-night-run]');
  if (!section) return;

  var LB_KEY = 'momentum_nightrun_scores';
  var NAME_KEY = 'momentum_nightrun_name';
  var canvas = section.querySelector('#NightRunCanvas');
  var ctx = canvas.getContext('2d');
  var shell = section.querySelector('[data-game-shell]');
  var overlay = section.querySelector('[data-game-overlay]');
  var hudScore = section.querySelector('[data-hud-score]');
  var hudTime = section.querySelector('[data-hud-time]');
  var hudBest = section.querySelector('[data-hud-best]');

  var ACCENT = getComputedStyle(document.documentElement).getPropertyValue('--color-accent').trim() || '#A855F7';

  var W = 800, H = 500;
  function resize() {
    var rect = canvas.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = rect.width; H = rect.height;
    canvas.width = W * dpr; canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  var LANES = 4;
  var state = {
    running: false, over: false,
    player: { lane: 1, x: 0, y: 0, w: 40, h: 64 },
    obstacles: [], particles: [],
    speed: 4, baseSpeed: 4, score: 0, dist: 0,
    startTime: 0, elapsed: 0, spawnT: 0, roadOffset: 0,
    move: 0
  };

  function laneX(lane) {
    var roadW = Math.min(W * 0.7, 420);
    var left = (W - roadW) / 2;
    var laneW = roadW / LANES;
    return left + laneW * lane + laneW / 2;
  }
  function laneWidth() { return Math.min(W * 0.7, 420) / LANES; }

  function reset() {
    state.player.lane = Math.floor(LANES / 2);
    state.obstacles = []; state.particles = [];
    state.speed = state.baseSpeed = 4.2;
    state.score = 0; state.dist = 0; state.spawnT = 0; state.roadOffset = 0;
    state.startTime = performance.now(); state.elapsed = 0;
    state.player.w = Math.max(30, laneWidth() * 0.5);
    state.player.h = state.player.w * 1.6;
    state.player.y = H - state.player.h - 24;
  }

  function spawn() {
    // choose 1-2 lanes to block, never all
    var blocked = {};
    var n = Math.random() < 0.35 ? 2 : 1;
    while (Object.keys(blocked).length < n) { blocked[Math.floor(Math.random() * LANES)] = true; }
    Object.keys(blocked).forEach(function (l) {
      var w = Math.max(28, laneWidth() * 0.52);
      state.obstacles.push({ lane: +l, x: laneX(+l), y: -80, w: w, h: w * 1.5, hue: Math.random() < 0.2 });
    });
  }

  function addParticles(x, y, color) {
    for (var i = 0; i < 16; i++) {
      state.particles.push({
        x: x, y: y, vx: (Math.random() - 0.5) * 6, vy: (Math.random() - 0.5) * 6 - 2,
        life: 1, color: color
      });
    }
  }

  function update(dt) {
    state.elapsed = (performance.now() - state.startTime) / 1000;
    state.speed = state.baseSpeed + state.elapsed * 0.16; // progressive
    state.dist += state.speed;
    state.score = Math.floor(state.dist / 10);
    state.roadOffset = (state.roadOffset + state.speed) % 80;

    // player smooth move toward lane
    var targetX = laneX(state.player.lane);
    state.player.x += (targetX - state.player.x) * Math.min(1, dt * 14);

    // spawn cadence shrinks with speed
    state.spawnT -= dt;
    if (state.spawnT <= 0) { spawn(); state.spawnT = Math.max(0.45, 1.15 - state.elapsed * 0.02); }

    // obstacles
    for (var i = state.obstacles.length - 1; i >= 0; i--) {
      var o = state.obstacles[i];
      o.y += state.speed;
      o.x = laneX(o.lane);
      if (o.y > H + 100) { state.obstacles.splice(i, 1); continue; }
      // collision
      var p = state.player;
      if (Math.abs(o.x - p.x) < (o.w + p.w) / 2 - 8 &&
          Math.abs((o.y + o.h / 2) - (p.y + p.h / 2)) < (o.h + p.h) / 2 - 10) {
        gameOver();
        return;
      }
    }
    // particles
    for (var j = state.particles.length - 1; j >= 0; j--) {
      var pt = state.particles[j];
      pt.x += pt.vx; pt.y += pt.vy; pt.vy += 0.2; pt.life -= dt * 1.6;
      if (pt.life <= 0) state.particles.splice(j, 1);
    }
  }

  function drawCar(x, y, w, h, color, isPlayer) {
    ctx.save();
    ctx.translate(x, y + h / 2);
    ctx.fillStyle = color;
    ctx.shadowColor = color; ctx.shadowBlur = isPlayer ? 18 : 8;
    roundRect(-w / 2, -h / 2, w, h, 6); ctx.fill();
    ctx.shadowBlur = 0;
    // windshield
    ctx.fillStyle = 'rgba(0,0,0,.45)';
    roundRect(-w / 2 + 5, -h / 2 + (isPlayer ? 8 : h - 22), w - 10, 14, 3); ctx.fill();
    // tail/head lights
    ctx.fillStyle = isPlayer ? '#fff' : 'rgba(255,255,255,.6)';
    ctx.fillRect(-w / 2 + 4, isPlayer ? -h / 2 + 2 : h / 2 - 5, 6, 3);
    ctx.fillRect(w / 2 - 10, isPlayer ? -h / 2 + 2 : h / 2 - 5, 6, 3);
    ctx.restore();
  }

  function roundRect(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    // bg
    ctx.fillStyle = '#060606'; ctx.fillRect(0, 0, W, H);

    var roadW = Math.min(W * 0.7, 420);
    var left = (W - roadW) / 2;
    // road
    ctx.fillStyle = '#0d0d10'; ctx.fillRect(left, 0, roadW, H);
    // edges
    ctx.fillStyle = ACCENT; ctx.globalAlpha = 0.5;
    ctx.fillRect(left - 3, 0, 3, H); ctx.fillRect(left + roadW, 0, 3, H);
    ctx.globalAlpha = 1;
    // lane dashes
    ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 2; ctx.setLineDash([26, 34]);
    ctx.lineDashOffset = -state.roadOffset;
    for (var l = 1; l < LANES; l++) {
      var lx = left + (roadW / LANES) * l;
      ctx.beginPath(); ctx.moveTo(lx, 0); ctx.lineTo(lx, H); ctx.stroke();
    }
    ctx.setLineDash([]);

    // obstacles
    state.obstacles.forEach(function (o) {
      drawCar(o.x, o.y, o.w, o.h, o.hue ? ACCENT : '#3a3a42', false);
    });
    // particles
    state.particles.forEach(function (p) {
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.fillStyle = p.color;
      ctx.fillRect(p.x, p.y, 4, 4);
    });
    ctx.globalAlpha = 1;
    // player
    if (state.running || state.over) drawCar(state.player.x, state.player.y, state.player.w, state.player.h, ACCENT, true);

    // HUD live
    hudScore.textContent = String(state.score).padStart(5, '0');
    hudTime.textContent = state.elapsed.toFixed(1) + 'S';
  }

  var last = 0;
  function loop(t) {
    if (!state.running) return;
    var dt = Math.min(0.05, (t - last) / 1000 || 0); last = t;
    update(dt);
    if (state.running) draw();
    if (state.running) requestAnimationFrame(loop);
  }

  function isLoggedIn() {
    return section.getAttribute('data-logged-in') === 'true';
  }

  function start() {
    if (!isLoggedIn()) {
      var url = section.getAttribute('data-login-url') || '/account/login';
      window.location.href = url;
      return;
    }
    resize();
    reset();
    state.running = true; state.over = false;
    overlay.hidden = true;
    last = performance.now();
    requestAnimationFrame(loop);
  }

  function playerName() {
    // Login is required, so the leaderboard always uses the account name.
    var acct = (section.getAttribute('data-player-name') || '').trim();
    return (acct || 'RIDER').toUpperCase().slice(0, 14);
  }

  function gameOver() {
    state.running = false; state.over = true;
    addParticles(state.player.x, state.player.y, ACCENT);
    draw();
    var name = playerName();
    var rank = scoreRank(state.score);          // 1-based position, or 0 if off the board
    var madeBoard = state.score > 0 && rank > 0 && rank <= 10;

    // Login-gated: save automatically under the account name. No manual entry.
    if (madeBoard) {
      saveScore(state.score, name);
      window.MOMENTUM_toast && window.MOMENTUM_toast('SCORE LOGGED', name + ' · ' + String(state.score).padStart(5, '0'));
      rank = scoreRank(state.score);
    }

    overlay.hidden = false;
    overlay.innerHTML =
      '<div>' +
        '<div class="eyebrow" style="justify-content:center">// RUN TERMINATED</div>' +
        '<h3>' + (rank === 1 && madeBoard ? 'NEW RECORD' : (madeBoard ? 'TOP 10' : 'WIPED OUT')) + '</h3>' +
        '<div class="score-final">SCORE ' + String(state.score).padStart(5, '0') + '</div>' +
        '<div class="sub">' + state.elapsed.toFixed(1) + 's survived · top speed ' + state.speed.toFixed(1) + '</div>' +
        (madeBoard
          ? '<div class="lb-name-saved">// LOGGED AS ' + escapeHtml(name) + ' · RANK ' + String(rank).padStart(2, '0') + '</div>'
          : '') +
        '<button class="btn" data-game-start>RIDE AGAIN</button>' +
        '<div class="game-controls-hint">← → or A / D to steer</div>' +
      '</div>';

    renderLeaderboard();
    bestLabel();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- leaderboard ---- */
  function getScores() {
    try { return JSON.parse(localStorage.getItem(LB_KEY)) || []; } catch (e) { return []; }
  }
  // where would this score rank right now? returns 1-based position
  function scoreRank(score) {
    var scores = getScores();
    var rank = 1;
    for (var i = 0; i < scores.length; i++) { if (scores[i].score > score) rank++; }
    return rank;
  }
  function saveScore(score, name) {
    if (score <= 0) return false;
    var scores = getScores();
    scores.push({ score: score, date: Date.now(), name: (name || 'RIDER').toUpperCase().slice(0, 14) });
    scores.sort(function (a, b) { return b.score - a.score; });
    scores = scores.slice(0, 10);
    localStorage.setItem(LB_KEY, JSON.stringify(scores));
    return scores[0].score === score;
  }
  function bestLabel() {
    var s = getScores();
    if (hudBest) hudBest.textContent = s.length ? String(s[0].score).padStart(5, '0') : '00000';
  }
  function renderLeaderboard() {
    var body = section.querySelector('[data-lb-body]');
    if (!body) return;
    var s = getScores();
    if (!s.length) { body.innerHTML = '<tr><td colspan="4" style="color:var(--color-muted)">// NO RUNS LOGGED</td></tr>'; return; }
    body.innerHTML = s.map(function (row, i) {
      var d = new Date(row.date);
      var ds = (d.getMonth() + 1) + '/' + d.getDate();
      var nm = escapeHtml(row.name || 'RDR');
      return '<tr><td class="rank">' + String(i + 1).padStart(2, '0') + '</td>' +
             '<td class="rider">' + nm + '</td>' +
             '<td>' + String(row.score).padStart(5, '0') + '</td>' +
             '<td style="color:var(--color-muted)">' + ds + '</td></tr>';
    }).join('');
  }

  /* ---- input ---- */
  function moveLane(dir) {
    if (!state.running) return;
    state.player.lane = Math.max(0, Math.min(LANES - 1, state.player.lane + dir));
  }
  window.addEventListener('keydown', function (e) {
    var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', ' ', 'Spacebar'];
    // only prevent scroll when game is running & visible
    if (state.running && keys.indexOf(e.key) > -1) e.preventDefault();
    if (!state.running) return;
    if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') moveLane(-1);
    if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') moveLane(1);
  }, { passive: false });

  // touch buttons
  section.querySelectorAll('[data-touch]').forEach(function (b) {
    b.addEventListener('click', function () { moveLane(b.getAttribute('data-touch') === 'left' ? -1 : 1); });
  });
  // swipe on canvas
  var touchX = null;
  canvas.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
  canvas.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 24) moveLane(dx > 0 ? 1 : -1);
    touchX = null;
  }, { passive: true });

  // start / again
  section.addEventListener('click', function (e) {
    if (e.target.closest('[data-game-start]')) start();
  });

  // fullscreen
  var fsBtn = section.querySelector('[data-game-fs]');
  if (fsBtn) {
    fsBtn.addEventListener('click', function () {
      shell.classList.toggle('is-fs');
      setTimeout(function () { resize(); if (!state.running) draw(); }, 60);
      fsBtn.textContent = shell.classList.contains('is-fs') ? 'EXIT FULLSCREEN' : 'FULLSCREEN';
    });
  }
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && shell.classList.contains('is-fs')) {
      shell.classList.remove('is-fs'); resize(); if (!state.running) draw();
      if (fsBtn) fsBtn.textContent = 'FULLSCREEN';
    }
  });

  // admin clear
  var clearBtn = section.querySelector('[data-lb-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      var pin = section.querySelector('[data-lb-pin]');
      if (pin && pin.value !== (section.getAttribute('data-admin-pin') || '0000')) {
        window.MOMENTUM_toast && window.MOMENTUM_toast('DENIED', 'Wrong admin PIN');
        return;
      }
      localStorage.removeItem(LB_KEY);
      renderLeaderboard(); bestLabel();
      window.MOMENTUM_toast && window.MOMENTUM_toast('LEADERBOARD WIPED', 'All runs cleared');
    });
  }

  window.addEventListener('resize', function () { resize(); if (!state.running) draw(); });

  // init
  resize();
  bestLabel();
  renderLeaderboard();
  draw();
})();
